import { Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const Congratulations = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const viewStatusBtnHandler = () => {
    navigate("/patient-details", { state: state });
  };
  const backBtnHandler = () => {
    navigate("/remote-care");
  };

  return (
    <div>
      <div className="w-full absolute top-[18%] left-0">
        <div className="mx-auto max-w-[1280px] w-full px-12 flex flex-col gap-y-2 items-center">
          <img
            src={require("./../../assets/images/success-animation.webp")}
            alt="success-animation"
            width={250}
            height={250}
          />
          <span className="font-semibold text-2xl">Congratulations!</span>
          <div className="font-medium text-base">
            Care plan referred successfully to <b>{state?.name}</b> 🎉
          </div>
        </div>
      </div>
      <div className="w-full fixed bottom-4 left-0">
        <div className="mx-auto max-w-[1280px] w-full p-4 flex flex-col gap-y-4">
          <Button
            type="primary"
            className="w-full h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
            onClick={viewStatusBtnHandler}
          >
            View Status
          </Button>
          <Button
            type="primary"
            className="w-full h-14 rounded-2xl border-[#4B4AD5] text-[#4B4AD5] bg-[transparent] p-5 text-lg font-medium"
            onClick={backBtnHandler}
          >
            Back To Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Congratulations;
